import {RegionModel} from './RegionModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ProviderModel} from './ProviderModel';

export class CalculatedChargeModel {
  id: number;
  numAnnoMese: number;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  resourceUnit: ResourcesUnitModel;
  contractType: ContractTypeModel;
  provider: ProviderModel;
  charge: number;
  isVolumeRecovery: number;

  constructor(  id?: number,
                numAnnoMese?: number,
                region?: RegionModel,
                localCustomer?: LocalCustomerModel,
                resourceUnit?: ResourcesUnitModel,
                contractType?: ContractTypeModel,
                provider?: ProviderModel,
                charge?: number,
                isVolumeRecovery?: number) {
    this.id = id;
    this.numAnnoMese = numAnnoMese;
    this.region = region;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.contractType = contractType;
    this.provider = provider;
    this.charge = charge;
    this.isVolumeRecovery = isVolumeRecovery;
  }
}
